import styled from 'styled-components';

export const InputContainer = styled.form`
    width: 100%;
    max-width: 900px;

    display: flex;
    flex-direction: row;
    align-items: center;
`;